import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { PasskeyButton } from '../components/Auth/PasskeyButton'
import { useAuthStore } from '../store/auth'

export function Register() {
  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const currentUser = useAuthStore((s) => s.username)

  if (currentUser) {
    navigate(`/~${currentUser}/journal`)
    return null
  }

  return (
    <div style={{ maxWidth: 400, margin: '4rem auto' }}>
      <h1>create account</h1>
      <br />
      {error && <p style={{ color: 'var(--color-1)', marginBottom: '1rem' }}>{error}</p>}
      <label>
        username
        <input value={username} onChange={(e) => setUsername(e.target.value)} />
      </label>
      <br />
      <label>
        email
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
      </label>
      <br />
      <br />
      <PasskeyButton
        username={username}
        email={email}
        mode="register"
        onSuccess={() => {
          useAuthStore.getState().setNeedsOnboarding()
          navigate('/welcome')
        }}
        onError={setError}
      />
      <p style={{ marginTop: '1.5rem', fontSize: '0.9rem' }}>
        already have an account? <Link to="/login">log in</Link>
      </p>
    </div>
  )
}
